import { lazy } from "react";
import { Route } from "react-router-dom";
const ContractLinkedRecords = lazy(() => import("./ContractLinkedRecords"));

const contractRoutes = 
<>
	<Route path="contracts/linked-records" element={<ContractLinkedRecords />} />
</>;

export default contractRoutes;